module.exports = __webpack_public_path__ + "img/ccmc-wilderverse-lg.7157476b.png";